const GameEvent = {
	START_LOADING: "start_loading",
	GAME_RESOURCES_LOADED: "game_resources_loaded",
	GAME_LOADED: "game_loaded",
	GAME_INITIALIZED: "game_initialized",
	ACTION_EXEC: "action_exec",
	BET_CHANGED: "bet_changed",
	FINISH_SPIN_ANIMATIONS: "finish_spin_animations",
	FINISH_ROUND_ANIMATIONS: "finish_round_animations",
	API_RESPONSE: "api_response",
	BALANCE_UPDATE: "balance_update",
	BUTTON_CLICK: 'button-click',
	PRE_PLAY: "pre_play",
	PLAY: "play",
	AUTOSPINS_STOPPED: "autospins_stopped",
	GO_HOME: "go_home",
	SET_SKIN: "set_skin",
	ERROR: "game_error",
	SET_LINES_COUNT: "set_lines_count",

	CUSTOM_EVENT: "custom_event",

	PLAY_REPLAY: "play_replay",
	RESTART_GAME: 'restart_game',
	SET_SPEED: 'set_speed',
    
	GAME_UI_BET_PANEL_OPENED: "game_ui_bet_panel_opened",
	GAME_UI_BET_PANEL_CLOSED: "game_ui_bet_panel_closed",
	GAME_UI_SETTINGS_OPENED: "game_ui_settings_opened",
	GAME_UI_SETTINGS_CLOSED: "game_ui_settings_closed",
	GAME_UI_RULES_OPENED: "game_ui_rules_opened",
	GAME_UI_RULES_CLOSED: "game_ui_rules_closed",
	GAME_UI_PAYTABLE_OPENED: "game_ui_paytable_opened",
	GAME_UI_PAYTABLE_CLOSED: "game_ui_paytable_closed",
	GAME_UI_AUTOSPINS_PANEL_OPENED: "game_ui_autospins_panel_opened",
	GAME_UI_AUTOSPINS_PANEL_CLOSED: "game_ui_autospins_panel_closed",
	GAME_UI_QUICK_SPIN_OFFER_OPENED: "game_ui_quick_spin_offer_opened",
	GAME_UI_QUICK_SPIN_OFFER_CLOSED: "game_ui_quick_spin_offer_closed",
};

export default GameEvent;
